module.exports = __webpack_public_path__ + "static/media/pthingslogo.5c960db8.png";